import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import "./style.css";
import BackArrow from "../../../components/backArrow";
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';


const ProjectSubmissionForm = ({ title,buttontitle }) => {
  return (
    <Row>
      <div className="screenHeight d-lg-flex justify-content-center  p-3">
        <Container className="form-container">
          <BackArrow />
          <h2 className="form-title">{title}</h2>
          <p className="text-left mb-3 font_12">
            Your project will undergo a thorough review process before being
            listed on our platform. We aim to provide a transparent and
            efficient evaluation to ensure the best opportunities for our
            investors.
          </p>

          <Form className="project-form-2 no-scrollbar">
            <Row>
              <Col md={6}>
                <Form.Group
                  controlId="projectTitle"
                  className="project-form-group-2"
                >
                  <Form.Label>Project Title</Form.Label>
                  <Form.Control type="text" placeholder="Enter project title" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group
                  controlId="projectImage"
                  className="project-form-group-2"
                >
              
                  <Form.Group controlId="projectImage" className="form-group">
                    <Form.Label>Project Display Image</Form.Label>
                    <div className="custom-file-upload">
                      <span style={{ fontSize: "12px" }}>Upload files</span>
                     <UploadOutlinedIcon className="upload-icon-form" />
                      <input type="file" />
                    </div>
                  </Form.Group>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group
                  controlId="projectCategory"
                  className="project-form-group-2"
                >
                  <Form.Label>Select Category</Form.Label>
                  <Form.Select>
                    <option>Project category</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group
                  controlId="fundingNeeded"
                  className="project-form-group-2"
                >
                  <Form.Label>Funding Needed ($)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter total funding required"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group
                  controlId="location"
                  className="project-form-group-2"
                >
                  <Form.Label>Location</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter project location"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group
                  controlId="expectedROI"
                  className="project-form-group-2"
                >
                  <Form.Label>Expected ROI (%)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter expected return on investment"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group
                  controlId="duration"
                  className="project-form-group-2"
                >
                  <Form.Label>Duration (Months)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter project duration in months"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group
                  controlId="minimumInvestment"
                  className="project-form-group-2"
                >
                  <Form.Label>Minimum Investment ($)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter minimum investment amount"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group
              controlId="projectDescription"
              className="project-form-group-2"
            >
              <Form.Label>Project Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter detailed description"
              />
            </Form.Group>

            <Form.Group controlId="legalDocs" className="project-form-group-2">
              <Form.Label>
                Pitch Deck / Legal Documents (optional for public view)
              </Form.Label>
              <Form.Group controlId="projectImage" className="form-group">
            
                <div className="custom-file-upload">
                  <span style={{ fontSize: "12px" }}>Upload files</span>
                  <UploadOutlinedIcon className="upload-icon-form" />
                  <input type="file" />
                </div>
              </Form.Group>
            </Form.Group>

            <h5 className="form-subtitle">Contact Information</h5>

            <Row>
              <Col md={6}>
                <Form.Group controlId="name" className="project-form-group-2">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter your name" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="email" className="project-form-group-2">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email address"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group
                  controlId="companyName"
                  className="project-form-group-2"
                >
                  <Form.Label>Company Name (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your company name"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="phone" className="project-form-group-2">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter your phone number"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="website" className="project-form-group-2">
              <Form.Label>Website / Social Link (Optional)</Form.Label>
              <Form.Control
                type="url"
                placeholder="Enter website or social media link"
              />
            </Form.Group>

            <Form.Group
              controlId="confirmation"
              className="project-project-form-group-2"
            >
              <Form.Check
                type="checkbox"
                label="I confirm that the information provided is accurate and I agree to the platform's terms and conditions."
              />
            </Form.Group>

            <div className="project-form-buttons">
              <Button
                variant="outline-secondary"
                className="project-cancel-button"
              >
                Cancel
              </Button>
              <Button variant="primary" className="project-submit-button">
                Submit for Review
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </Row>
  );
};

export default ProjectSubmissionForm;
